import { Components, Theme } from '@mui/material';

export default {
  defaultProps: {
    variant: 'body1Bold',
  },
} as Components<Theme>['MuiLink'];
